import { jsx as r } from "react/jsx-runtime";
import { c as e } from "../../../index-Cu0xwYjD.js";
import { useIcons as a } from "../../providers/IconsProvider.js";
import "../../providers/PictogramsProvider.js";
import "react";
import "../../../ThemeContext-CW6LNpDq.js";
import '../../../assets/Icon.css';const l = "_icon_1xezl_4", m = {
  icon: l
}, _ = ({ name: o, size: t = "1em", className: c, ...i }) => {
  const n = a(), s = o && n[o];
  return s ? /* @__PURE__ */ r(
    s,
    {
      "data-testid": `element-icon${o ? `-${o}` : ""}`,
      "data-icon": o,
      width: t,
      height: t,
      focusable: "false",
      "aria-hidden": "true",
      className: e(m.icon, c),
      ...i
    }
  ) : null;
};
export {
  _ as Icon
};
